'use strict';
var global = require('../internals/global');

module.exports = function (CONSTRUCTOR) {
  return global[CONSTRUCTOR].prototype;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/entry-virtual.js
// module id = 430
// module chunks = 31